var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#triangle-warning_svg__clip0_8632_24046)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#triangle-warning_svg__clip1_8632_24046)",
    fill: "#FFC834"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.505 7.22c.154 3.352-.087 6.703 0 10.055a.784.784 0 00.26.5.805.805 0 001.066 0 .785.785 0 00.26-.5c-.086-3.352.155-6.703 0-10.055-.047-1.007-1.634-1.007-1.586 0zM13.332 20.55a.802.802 0 00.507-.257.782.782 0 000-1.051.802.802 0 00-.507-.258.802.802 0 00-.507.258.782.782 0 000 1.051.802.802 0 00.507.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.38 1.979C8.917 6.603 7.099 12.129 4.492 17.17c-.76 1.49-1.722 2.848-2.415 4.424-.202.456-.452 1.026 0 1.453.452.427 1.549.275 2.194.266 2.76 0 5.502 0 8.272-.076 2.77-.076 5.426.19 8.138.218.914 0 3.742.56 4.117-.55.231-.694-.52-1.9-.788-2.545a28.833 28.833 0 00-1.27-2.63c-1.414-2.478-2.54-5.109-3.906-7.596-1.53-2.849-3.203-5.517-4.954-8.185-.51-.769-1.76-.057-1.25.722a105.74 105.74 0 017.512 13.17c.732 1.594 1.655 3.095 2.367 4.69.23.513.452 1.025.635 1.548a4.7 4.7 0 00.192.55l.5-.54h-.327a9.741 9.741 0 00-1.972 0c-2.308 0-4.617-.143-6.926-.229-2.578-.104-5.156.18-7.743.095h-2.78a5.856 5.856 0 00-1.087 0l.279.589.077-.2c.099-.158.18-.327.24-.503.674-1.339 1.491-2.592 2.174-3.93 2.597-5.08 4.425-10.616 7.878-15.193.558-.74-.702-1.453-1.24-.721l-.03-.02z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "triangle-warning_svg__clip0_8632_24046"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.74 .646)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "triangle-warning_svg__clip1_8632_24046"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.818 1.646)",
    d: "M0 0h23v22H0z"
  })))));
}
export default SvgTriangleWarning;